module.exports = __webpack_public_path__ + "img/Switch-2@2x.1b7ff4e3.svg";